// <auto-generated />
// The class was autogenerated by .services.tst.
// Any manual changes made to this file will be lost. To regenerate the content,
// right click .services.tst and select 'Render Template'. Please note that you
// must have the Typewriter Visual Studio extension installed for this to work.
import Axios, { AxiosRequestConfig } from "axios";
import * as qs from "qs";
import { Area } from "./Area";
import { DeleteProfileResponse } from "./DeleteProfileResponse";
import { GetAreasResponse } from "./GetAreasResponse";
import { GetNonUniqueProfilesResponse } from "./GetNonUniqueProfilesResponse";
import { GetUserAreasResponse } from "./GetUserAreasResponse";
import { GetUserListResponse } from "./GetUserListResponse";
import { Profile } from "./Profile";
import { SetUserAreasArgs } from "./SetUserAreasArgs";
import { UpsertProfileResponse } from "./UpsertProfileResponse";
import { UpsertUserResponse } from "./UpsertUserResponse";
import { UserArea } from "./UserArea";
import { UserDetails } from "./UserDetails";

export class AdminApiController {
   static readonly getUserListParams = {
   };

   static readonly getNonUniqueProfilesParams = {
   };

   static readonly getProfilesParams = {
       userId: "userId"
   };

   static readonly getUserProfileParams = {
   };

   static readonly addProfileParams = {
       profile: "profile"
   };

   static readonly updateProfileParams = {
       profile: "profile"
   };

   static readonly deleteProfileParams = {
       profileId: "profileId"
   };

   static readonly deleteUserParams = {
       userId: "userId"
   };

   static readonly addUserParams = {
       user: "user"
   };

   static readonly updateUserParams = {
       updatedUser: "updatedUser"
   };

   static readonly updateUserPasswordParams = {
       userDetails: "userDetails"
   };

   static readonly getAreasParams = {
   };

   static readonly addAreaParams = {
       area: "area"
   };

   static readonly updateAreaParams = {
       newArea: "newArea"
   };

   static readonly deactivateUserParams = {
       userId: "userId"
   };

   static readonly deleteAreaParams = {
       areaId: "areaId"
   };

   static readonly getUserAreasParams = {
   };

   static readonly addUserAreaParams = {
       userArea: "userArea"
   };

   static readonly addUserAreasParams = {
       userAreas: "userAreas"
   };

   static readonly setUserAreasParams = {
       args: "args"
   };

   static readonly deleteUserAreaParams = {
       userId: "userId",
       areaId: "areaId"
   };

   static readonly deleteUserAreasParams = {
       userAreas: "userAreas"
   };

   static readonly ssoEnabledParams = {
   };

   static async getUserList(config?: Partial<AxiosRequestConfig>): Promise<GetUserListResponse> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/getUserList`
           });
       return request.data;
   }

   static async getNonUniqueProfiles(config?: Partial<AxiosRequestConfig>): Promise<GetNonUniqueProfilesResponse> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/getNonUniqueProfiles`
           });
       return request.data;
   }

   static async getProfiles(userId?: number, config?: Partial<AxiosRequestConfig>): Promise<Profile[]> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/getProfiles?userId=${userId}`
           });
       return request.data;
   }

   static async getUserProfile(config?: Partial<AxiosRequestConfig>): Promise<Profile> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/getUserProfile`
           });
       return request.data;
   }

   static async addProfile(profile: Profile, config?: Partial<AxiosRequestConfig>): Promise<UpsertProfileResponse> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: profile,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/addProfile`
           });
       return request.data;
   }

   static async updateProfile(profile: Profile, config?: Partial<AxiosRequestConfig>): Promise<UpsertProfileResponse> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: profile,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/updateProfile`
           });
       return request.data;
   }

   static async deleteProfile(profileId: number, config?: Partial<AxiosRequestConfig>): Promise<DeleteProfileResponse> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/deleteProfile?profileId=${profileId}`
           });
       return request.data;
   }

   static async deleteUser(userId: number, config?: Partial<AxiosRequestConfig>): Promise<void> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/deleteUser?userId=${userId}`
           });
       return request.data;
   }

   static async addUser(user: UserDetails, config?: Partial<AxiosRequestConfig>): Promise<UpsertUserResponse> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: user,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/addUser`
           });
       return request.data;
   }

   static async updateUser(updatedUser: UserDetails, config?: Partial<AxiosRequestConfig>): Promise<UpsertUserResponse> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: updatedUser,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/updateUser`
           });
       return request.data;
   }

   static async updateUserPassword(userDetails: UserDetails, config?: Partial<AxiosRequestConfig>): Promise<UserDetails> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: userDetails,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/updateUserPassword`
           });
       return request.data;
   }

   static async getAreas(config?: Partial<AxiosRequestConfig>): Promise<GetAreasResponse> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/getAreas`
           });
       return request.data;
   }

   static async addArea(area: Area, config?: Partial<AxiosRequestConfig>): Promise<GetAreasResponse> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: area,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/addArea`
           });
       return request.data;
   }

   static async updateArea(newArea: Area, config?: Partial<AxiosRequestConfig>): Promise<GetAreasResponse> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: newArea,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/updateArea`
           });
       return request.data;
   }

   static async deactivateUser(userId: number, config?: Partial<AxiosRequestConfig>): Promise<UserDetails> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/deactivateUser?userId=${userId}`
           });
       return request.data;
   }

   static async deleteArea(areaId: number, config?: Partial<AxiosRequestConfig>): Promise<GetAreasResponse> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/deleteArea?areaId=${areaId}`
           });
       return request.data;
   }

   static async getUserAreas(config?: Partial<AxiosRequestConfig>): Promise<GetUserAreasResponse> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/getUserAreas`
           });
       return request.data;
   }

   static async addUserArea(userArea: UserArea, config?: Partial<AxiosRequestConfig>): Promise<number> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: userArea,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/addUserArea`
           });
       return request.data;
   }

   static async addUserAreas(userAreas: UserArea[], config?: Partial<AxiosRequestConfig>): Promise<number> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: userAreas,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/addUserAreas`
           });
       return request.data;
   }

   static async setUserAreas(args: SetUserAreasArgs, config?: Partial<AxiosRequestConfig>): Promise<UserArea[]> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: args,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/setUserAreas`
           });
       return request.data;
   }

   static async deleteUserArea(userId: number, areaId: number, config?: Partial<AxiosRequestConfig>): Promise<number> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/deleteUserArea?userId=${userId}&areaId=${areaId}`
           });
       return request.data;
   }

   static async deleteUserAreas(userAreas: UserArea[], config?: Partial<AxiosRequestConfig>): Promise<number> {
       const request =
           await Axios({
               ...config,
               method: "post",
               data: userAreas,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/deleteUserAreas`
           });
       return request.data;
   }

   static async ssoEnabled(config?: Partial<AxiosRequestConfig>): Promise<boolean> {
       const request =
           await Axios({
               ...config,
               method: "get",
               params: null,
               paramsSerializer: o => qs.stringify(o, { arrayFormat: "repeat" }),
               url: `/api/AdminApi/ssoEnabled`
           });
       return request.data;
   }
}